module.exports = {"340825100":"晋熙镇","340825101":"徐桥镇","340825102":"新仓镇","340825103":"小池镇","340825104":"寺前镇","340825105":"天华镇","340825106":"牛镇镇","340825107":"弥陀镇","340825108":"北中镇","340825109":"百里镇","340825200":"大石乡","340825201":"城西乡","340825202":"江塘乡","340825203":"汤泉乡","340825204":"刘畈乡","340825400":"经济开发区","340825401":"花凉亭水电站"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340825.json
// module id = 1096
// module chunks = 0